import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { TitleInsuranceProvider } from '@models/title-insurance';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { BlankTitleInsurance } from '../../../chicago/chicago.component';
import { AddTitleInsuranceComponent } from '../../../components/add-title-insurance/add-title-insurance.component';
import { ClearOrderModalComponent } from '../clear-order-modal/clear-order-modal.component';
import { SwitchToIntegratedModalComponent } from '../switch-to-integrated-modal/switch-to-integrated-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { Select } from '@ngxs/store';
import { MatterPropertyType } from '@models/matter';
import { PropertyUsage } from '@models/title-insurance';
import { Observable } from 'rxjs';
import { TestHooks } from './header.hooks';

@UntilDestroy()
@Component({
	selector: 'app-manual-title-insurance-header',
	templateUrl: './header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class HeaderComponent {
	testHooks = TestHooks;
	@Input() companyLogo: string;
	@Input() company: string;
	public ICON = ICON;
	public titleInsuranceProvider = TitleInsuranceProvider;
	public blankTitleInsurance = BlankTitleInsurance;
	public propertyUsage = PropertyUsage;

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SelectedMatter.propertyType)
	propertyType$: Observable<MatterPropertyType>;

	constructor(
		private dialog: MatDialog,
		private matterDispatch: MatterDispatch,
	) {}

	switchToIntegrated(): void {
		this.dialog
			.open(SwitchToIntegratedModalComponent, {
				width: '550px',
				maxWidth: '90vw',
			})
			.afterClosed()
			.pipe(
				untilDestroyed(this),
				filter((result) => !!result),
			)
			.subscribe(() => this.dialog.open(AddTitleInsuranceComponent));
	}

	clear(): void {
		this.dialog
			.open(ClearOrderModalComponent)
			.afterClosed()
			.pipe(
				untilDestroyed(this),
				filter((result) => !!result),
			)
			.subscribe(() =>
				this.matterDispatch.SetTitleInsurance(
					this.matterId,
					this.blankTitleInsurance,
				),
			);
	}
}
